// import pacchetti
import { useState } from "react";
import Select from "react-select";

// import styles
import "./Project.css";

export default function ProjectSAL({ prj, onUpdateStatus, onUpdate }) {
  const [avanzamento, setAvanzamento] = useState(prj.avanzamento || "");
  const [status, setStatus] = useState(null);
  const [salError, setSalError] = useState(null);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSalError(null);

    if (!avanzamento && !status) {
      setSalError("Inserisci almeno un valore da aggiornare");
      return;
    }

    // Aggiorna avanzamento se presente
    if (avanzamento) {
      const updateData = {
        avanzamento: parseInt(avanzamento),
      };
      onUpdate(updateData);
    }

    // Aggiorna stato se presente
    if (status) {
      onUpdateStatus(status.value);
    }
  };

  return (
    <form className="project-section sal-form" onSubmit={handleSubmit}>
      <div className="sal-inputs">
        <label>
          <span>Avanzamento (%):</span>
          <input
            type="number"
            min="0"
            max="100"
            onChange={(e) => setAvanzamento(e.target.value)}
            value={avanzamento}
            placeholder="Inserisci percentuale avanzamento"
          />
        </label>

        <label>
          <span>Stato Cantiere:</span>
          <Select
            onChange={(option) => setStatus(option)}
            options={[
              { value: true, label: "Completato" },
              { value: false, label: "Aperto" },
            ]}
            isSearchable={false}
            placeholder="Seleziona nuovo stato"
            isClearable
          />
        </label>
      </div>

      <button className="btn">Aggiorna SAL</button>
      {salError && <p className="error">{salError}</p>}
    </form>
  );
}
